import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
const shimmer = keyframes `
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;
const sizeStyles = {
    sm: css `
    padding: 0.375rem 0.875rem;
    font-size: 0.8125rem;
    border-radius: 9999px;
    letter-spacing: 0.01em;
  `,
    md: css `
    padding: 0.5625rem 1.25rem;
    font-size: 0.9375rem;
    border-radius: 9999px;
  `,
    lg: css `
    padding: 0.8125rem 2rem;
    font-size: 1rem;
    border-radius: 9999px;
    letter-spacing: -0.01em;
  `,
};
const variantStyles = (theme) => ({
    primary: css `
    background: linear-gradient(
      120deg,
      ${theme.colors.brand.primary} 0%,
      ${theme.mode === 'dark' ? '#a855f7' : theme.colors.brand.primaryHover} 50%,
      ${theme.colors.brand.accent} 100%
    );
    background-size: 200% auto;
    color: white;
    font-weight: 600;
    box-shadow: 0 0 0 0 rgba(139, 92, 246, 0);
    &:hover:not(:disabled) {
      animation: ${shimmer} 1.8s linear infinite;
      box-shadow: ${theme.shadows.glow};
      transform: translateY(-1px);
    }
    &:active:not(:disabled) {
      transform: translateY(0);
    }
  `,
    secondary: css `
    background: ${theme.colors.bg.tertiary};
    color: ${theme.colors.text.primary};
    border: 1px solid ${theme.colors.border.default};
    font-weight: 500;
    &:hover:not(:disabled) {
      background: ${theme.colors.bg.secondary};
      border-color: ${theme.colors.brand.primary}60;
      color: ${theme.colors.brand.primaryHover};
    }
  `,
    ghost: css `
    background: transparent;
    color: ${theme.colors.text.secondary};
    font-weight: 500;
    &:hover:not(:disabled) {
      background: ${theme.colors.bg.tertiary};
      color: ${theme.colors.text.primary};
    }
  `,
    danger: css `
    background: ${theme.colors.error};
    color: white;
    font-weight: 600;
    &:hover:not(:disabled) {
      filter: brightness(1.15);
      box-shadow: 0 0 20px ${theme.colors.error}50;
    }
  `,
    accent: css `
    background: linear-gradient(
      120deg,
      ${theme.colors.brand.accent} 0%,
      ${theme.colors.brand.accentHover} 100%
    );
    background-size: 200% auto;
    color: #020205;
    font-weight: 600;
    &:hover:not(:disabled) {
      animation: ${shimmer} 1.8s linear infinite;
      box-shadow: ${theme.shadows.glowAccent};
      transform: translateY(-1px);
    }
  `,
});
export const Button = styled.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  transition: all 220ms cubic-bezier(0.16, 1, 0.3, 1);
  user-select: none;
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  overflow: hidden;

  ${({ size = 'md' }) => sizeStyles[size]}
  ${({ theme, variant = 'primary' }) => variantStyles(theme)[variant]}
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    transform: none !important;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.brand.primary};
    outline-offset: 3px;
  }

  ${({ loading }) => loading &&
    css `
      cursor: wait;
      pointer-events: none;
      opacity: 0.7;
    `}
`;
//# sourceMappingURL=Button.js.map